$(document).ready(function() {
  var pickupLabel = "In-Store/Curbside Pickup?"; // the text of the label
  var deliveryLabel = "Local School Delivery?";
  var buttonArea = $('.cart .totals'); // where to insert the option
  var pickupVariantId = 6066030510118; // the variant ID of the local pickup product
  var deliveryVariantId = 6066086608934;

  Shopify.getCart(function(cart) {
    var pickupInCart = false;
    var deliveryInCart = false;
    $.each(cart.items, function(index, item) {
      if (item.variant_id == pickupVariantId) {
        pickupInCart = true;
        return false;
      }
    });
    $.each(cart.items, function(index, item) {
      if (item.variant_id == deliveryVariantId) {
        deliveryInCart = true;
        return false;
      }
    });
    buttonArea.append('<label for="school-delivery"><input id="school-delivery" type="checkbox"' + (deliveryInCart ? ' checked' : '') + ' /> ' + deliveryLabel + '</label></div>');
  });

  buttonArea.on('change', '#in-store-pickup', function() {
    if ($(this).is(':checked')) {
      Shopify.addItem(pickupVariantId, 1, function(item) {
        location.reload();
      });
    } else {
      Shopify.changeItem(pickupVariantId, 0, function(cart) {
        location.reload();
      });
    }
  });

  buttonArea.on('change', '#school-delivery', function() {
    if ($(this).is(':checked')) {
      Shopify.addItem(deliveryVariantId, 1, function(item) {
        location.reload();
      });

      document.getElementById("school_name").classList.remove("hide");

    } else {
      Shopify.changeItem(deliveryVariantId, 0, function(cart) {
        location.reload();
      });

      document.getElementById("school_name").classList.add("hide");

    }
  });

});
